import { Typography } from "@mui/material";
import logo from "../img/image-Photoroom (1).png";
import image from "../img/a.png";
import { useTranslation } from "react-i18next";

export const EscalatorPreventiveBill = ({ data, reporteRef }) => {
  const { t } = useTranslation();

  const date = new Date(data.start_time);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear().toString().slice(-2);

  const tableData = generateTableData();
  const groupedData = groupTableData();
  const mensuales1 = groupedData.Mensuales1;
  const mensuales2 = groupedData.Mensuales2;
  const recorrido = groupedData.Recorrido;
  const pasamanos = groupedData.Pasamanos;
  const control = groupedData.Control;

  function groupTableData() {
    const grouped = {
      Mensuales1: [],
      Mensuales2: [],
      Recorrido: [],
      Pasamanos: [],
      Control: [],
    };

    tableData.forEach((item) => {
      const [group, text] = item.task.split("--").map((s) => s.trim());
      if (grouped[group]) {
        grouped[group].push({ ...item, task: text });
      }
    });

    return grouped;
  }

  function generateTableData() {
    const statusMap = data.schedule_checklists.reduce((map, item) => {
      map[item.checklist_question_id] = item.notes || "";
      return map;
    }, {});

    return data.questions.map((question) => {
      const status = statusMap[question.id] || "";
      return {
        task: question.question,
        status: status === "" ? "-" : "✔",
      };
    });
  }

  const startTime = new Date(data.start_time).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const endTime = new Date(data.end_time).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const containerStyle = {
    fontFamily: "Arial, sans-serif",
    fontSize: "9px",
    border: "1px solid black",
    width: `${210 * 3.78}px`,
    height: `${297 * 3.78}px`,
    boxSizing: "border-box",
  };

  const renderTable = (title, dataArray) => (
    <div style={{ width: "49%", textAlign: "center", padding: "2px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid black",
                padding: "2px",
                backgroundColor: "#f2f2f2",
              }}
            >
              {title}
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "2px",
                backgroundColor: "#f2f2f2",
              }}
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {dataArray.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  border: "1px solid black",
                  padding: "2px",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {row.task}
              </td>
              <td style={{ border: "1px solid black", padding: "2px" }}>
                {row.status}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div ref={reporteRef} style={containerStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "0 10px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="h6"
            style={{ fontSize: "9px", marginTop: "10px" }}
          >
            F-MTTO {data?.id}. Mantenimiento preventivo escaleras eléctricas
          </Typography>
          <div style={{ marginTop: "30px" }}>
            <h1 style={{ fontSize: "13px", marginBottom: "0" }}>
              REPORTE DE VISITA MANTENIMIENTO EQUIPOS
            </h1>
            <h2 style={{ fontSize: "13px" }}>ESCALERAS ELÉCTRICAS Y RAMPAS</h2>
          </div>
        </div>
        <div style={{ width: "20%", marginTop: "10px", textAlign: "right" }}>
          <img src={logo} alt="Logo" style={{ width: "100%" }} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          marginTop: "5px",
          borderTop: "1px solid black",
        }}
      >
        <div
          style={{
            width: "50%",
            borderRight: "1px solid black",
            padding: "4px",
          }}
        >
          <strong>Fecha Visita:</strong> {`${day}/${month}/${year}`}
        </div>
        <div style={{ width: "50%", padding: "4px" }}>
          <strong>Hora Ingreso:</strong> {startTime} | <strong>Salida:</strong>{" "}
          {endTime}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          borderTop: "1px solid black",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: "4px",
          }}
        >
          <strong>Cliente:</strong> {data.client?.name} {data.place}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          borderTop: "1px solid black",
          borderBottom: "1px solid black",
        }}
      >
        <div
          style={{
            width: "50%",
            borderRight: "1px solid black",
            padding: "4px",
          }}
        >
          <strong>Torre:</strong> {data.elevator?.building?.name}
        </div>
        <div style={{ width: "50%", padding: "4px" }}>
          <strong>Equipo:</strong> {data.elevator?.identifier} |{" "}
          <strong>Estado:</strong> {t(data.status)}
        </div>
      </div>

      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "70%",
            display: "flex",
            flexWrap: "wrap",
            gap: "6px",
          }}
        >
          {renderTable("Mensuales - Parte 1", mensuales1)}
          {renderTable("Mensuales - Parte 2", mensuales2)}
          {renderTable("Trimestral - Recorrido", recorrido)}
          {renderTable("Trimestral - Pasamanos", pasamanos)}
          {renderTable("Control", control)}
        </div>
        <div style={{ width: "30%", marginTop: "20px" }}>
          <img src={image} alt="Imagen" style={{ width: "100%" }} />
        </div>
      </div>

      <div style={{ height: "20px" }} />

      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography variant="h6" style={{ fontSize: "9px" }}>
            Observaciones
          </Typography>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography variant="h6" style={{ fontSize: "9px" }}>
            {data.description || ""}
          </Typography>
        </div>
      </div>

      <div style={{ display: "flex", marginTop: "0" }}>
        <div
          style={{
            width: "50%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
            padding: "5px",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "10px", margin: "2px 0" }}
          >
            Firma Cliente
          </Typography>
          <div style={{ height: "60px" }}>
            {data.signature_url && (
              <img
                src={data.signature_url}
                alt="Firma Cliente"
                style={{ maxHeight: "100%", maxWidth: "100%" }}
                crossOrigin="anonymous"
              />
            )}
          </div>
          <Typography variant="h6" style={{ fontSize: "9px", margin: "2px 0" }}>
            Nombre: {data.person_name}
          </Typography>
          <Typography variant="h6" style={{ fontSize: "9px", margin: "2px 0" }}>
            C.C: {data.document}
          </Typography>
        </div>
        <div
          style={{
            width: "50%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
            padding: "5px",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "10px", margin: "2px 0" }}
          >
            Firma Técnico
          </Typography>
          <div style={{ height: "60px" }}>
            {data.technicianSignature && (
              <img
                src={data.technicianSignature}
                alt="Firma Técnico"
                style={{ maxHeight: "100%", maxWidth: "100%" }}
              />
            )}
          </div>
          <Typography variant="h6" style={{ fontSize: "9px", margin: "2px 0" }}>
            Nombre: {data.user?.name}
          </Typography>
          <Typography variant="h6" style={{ fontSize: "9px", margin: "2px 0" }}>
            C.C: {data.user?.document}
          </Typography>
        </div>
      </div>
    </div>
  );
};
